import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfFocusScoreService } from '../../../core/application/services/scores/get-self-focus-score.service';
import { SelfFocusScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-focus-score.aggregate-root';
import { GetSelfAllScoresRequestDto } from '../../dtos/scores/self-get-all-scores.request.dto';

export class GetSelfFocusScoreQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfFocusScoreService
  ) {}
  async execute(
    props: GetSelfAllScoresRequestDto
  ): Promise<SelfFocusScoreAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
